import Superscript from "@/components/ui/superscript";
export const keyFacts = [
  {
    title: <>Number of internal migrants</>,
    description: (
      <>
        29.87 million internal migrants move for work
        <Superscript
          path="https://psa.gov.ph/content/migration-and-overseas-workers-2020-census-population-and-housing-2020-cph"
          index="1"
        />{" "}
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    title: <>Migration trends</>,
    description: (
      <>
        Rural to rural migration (46%) dominates migration flow in Philippines,
        followed by rural to urban (35%) for lifetime migrants.
        <Superscript
          path="https://www.uppi.upd.edu.ph/sites/default/files/pdf/2018 NMS Final Report.pdf"
          index="2"
        />{" "}
      </>
    ),
    icon: "/images/icons/urbanization.png",
  },
  {
    title: <>Key destination areas</>,
    description: (
      <>
        Calabarzon, National Capital Region and Central Luzon
        <Superscript
          path="https://psa.gov.ph/content/migration-and-overseas-workers-2020-census-population-and-housing-2020-cph"
          index="3"
        />
      </>
    ),
    icon: "/images/icons/destination (2).png",
  },
  {
    title: (
      <>
        Prominent sectors of employment for migrants{" "}
        <Superscript
          path="https://www.uppi.upd.edu.ph/sites/default/files/pdf/2018 NMS Final Report.pdf"
          index="4"
        />
      </>
    ),
    description: (
      <>
        Agriculture, forestry and fishing, wholesale and retail trade; and
        construction
      </>
    ),
    icon: "/images/icons/job.png",
  },
];
export const climateImpacts = [
  {
    description: (
      <>
        By the end of this century, an estimated 60 million people residing in
        coastal areas are predicted to move as a result of rising sea levels in
        the country.
        <Superscript
          path="https://philippines.un.org/en/156235-climate-crisis-game-changer-when-it-comes-migration?afd_azwaf_tok=eyJhbGciOiJSUzI1NiJ9.eyJhdWQiOiJwaGlsaXBwaW5lcy51bi5vcmciLCJleHAiOjE3MjU0NDYxMjgsImlhdCI6MTcyNTQ0NTgyOCwiaXNzIjoidGllcjEtNzU5ODk5Yzk2OC1kendydiIsInN1YiI6IjEyNDo0OTo0MDg4OjllMTI6ZTM3ODo2MTlmOjNjMjI6MWE4MCIsImRhdGEiOnsidHlwZSI6Imlzc3VlZCIsInJlZiI6IjIwMjQwOTA0VDEwMzAyOFotMTc1OTg5OWM5NjhkendydjB0dWE2ZjlibncwMDAwMDAwcHowMDAwMDAwMDBrYzI5IiwiYiI6IkxTekhNMjBydDZxdGtXVmJCcEVLWXZTNHo2b1BlMmh6MGZVSXM0Sk15WkEiLCJoIjoiOXNHRlVibjJvNjFEdml4cllVcFY2WWpTcTAtMlZWN2EyQjJzTFNpTWJLYyJ9fQ.EkDI9YXDtEJHAZz_ivKMyw3afVdviRgX3rb8H_Y-J4ji_puPrJaIN3aJ3U_0gW2T6ttNmW0auQN2BKNHi_7aVIM6zA7_3GO2J9F4FfKgD5GAPP2czHgCpwT5Kp276pJkWqp_TK6Ph2YXnKlAlKp8e00ZhDJAhhGM_CMEpCROFN736Gxmwn-LF8No3vaGl7qjOVnlf2kSgs9UnImVQR-Pn9XoXixic2MnZtVxy-JtSn85tIqJnfvss5yxXLQYI_wKx7bIU0ccrIxv9NXktQy7BCebeXWhOtRlP6sT9-EFPGMo7t4JIUj4oSucfu7G9_FRYOMLC9fwXOArG4lhD_ksZA.WF3obl2IDtqgvMFRqVdYkD5s"
          index="7"
        />
      </>
    ),
    icon: "/images/icons/migration.png",
  },
  {
    description: (
      <>
        Top three impacts at destination top three negative livelihood impacts
        are wage cut (40%), wage loss (39%) and no impacts (27%), and top three
        negative household impacts are health issues (38%), no impact (24%) and
        house damage (21%). (Sample size - 1371)
      </>
    ),
    icon: "/images/icons/impact.png",
  },
  {
    description: (
      <>
        Top three impacts at source on livelihoods are job loss (64%), wage loss
        (24%) and wage cut (17%), and top three negative household impacts are
        house damage (84%), house destroyed (13%) and loss of access to water or
        sanitation services (7%) livelihoods impacts. (Sample size - 1076)
      </>
    ),
    icon: "/images/icons/home.png",
  },
];
export const stories = [
  {
    title: "To Higher Ground: Eric's Dream of a Better Life",
    description: "",
    videoPath: "https://youtu.be/j5n0CWYgwy8",
  },
  {
    title: "Traversing Typhoons: Margilita's Unwavering Resilience",
    description: "",
    videoPath: "https://youtu.be/zRLme2Ef7UY",
  },
];

export const partners = [
  // {
  //   link: "https://pkkk.org/who-we-are/how-we-started/",
  //   title: "Lorem Ipsum",
  //   logo: "/images/phillipines/pkkk.jpg",
  // },
  {
    link: "https://foundation.aski.com.ph/about-us.php",
    title: "Lorem Ipsum",
    logo: "/images/phillipines/aski.png",
  },
  {
    link: "https://www.facebook.com/mindanaomigrant/",
    title: "Lorem Ipsum",
    logo: "/images/phillipines/mmceai.webp",
  },
];

export const seo = {
  slug: "/philippines",
  metaTitle:
    "Philippines | People’s Courage International, South & Southeast Asia",
};

export const jsonLd = {
  "@context": "http://www.schema.org",
  "@type": "Organization",
  name: "People’s Courage International",
  description:
    "People’s Courage International is a USA-based not-for-profit organization. Join our charity and help us provide critical support to those in need around the world.",
  address: {
    "@type": "PostalAddress",
    streetAddress: "3206 10th Street NE, Washington",
    addressLocality: "DC",
    postalCode: "20017",
    addressCountry: "USA",
  },
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+1202-573-8727",
    contactType: "customer support",
  },
};

export const insights = [
  {
    heading:
      "Large-scale internal migration has impacted both rural and urban areas in the Philippines",
    text: `The 2020 Census of Population and Housing observed, 30.6% of Filipinos moved to or lived in another area within domestic borders.<sup><a href="https://www.bworldonline.com/economy/2023/01/16/498774/internal-migrants-estimated-at-over-30-of-phl-population/" target="_blank" rel="noreferrer">[8]</a></sup> Most of those who move internally from rural to urban locations, generally migrate at a relatively young age impacting overall conditions in both areas. Research has indicated that as the young population moves from rural areas, it leaves a deficit in the labour force. This could eventually lead to a decline in agricultural production and an increasingly ageing population. Consequently, urban areas are strained as a result of increased housing and infrastructural requirements leading to a further increase in informal settlements.<sup><a href="https://www.bsp.gov.ph/Pages/MediaAndResearch/PublicationsAndReports/Discussion Papers/DP202301.pdf" target="_blank" rel="noreferrer">[9]</a></sup>`,
    image: "/images/phillipines/story-1.webp",
  },
  {
    heading:
      "Rising temperatures and sea levels have led to an increase in internal migration",
    text: `As a result of climate change, the Philippines has experienced an increase in temperature and sea level rise in coastal cities leading to an increase in internal migration. Experts have found that increased temperature has resulted in a high out migration from rural areas owing to low agricultural productivity. Simultaneously, the increase in sea level has led to more instances of typhoons and hence displacement.<sup><a href="https://www.american.edu/cas/economics/ejournal/upload/12_2_petelo.pdf" target="_blank" rel="noreferrer">[10]</a></sup> For example, the sea level in the capital city of Manila is found to be rising “more than four times faster than the global average”.<sup><a href="https://www.american.edu/cas/economics/ejournal/upload/12_2_petelo.pdf" target="_blank" rel="noreferrer">[11]</a></sup> Furthermore, it is estimated that by the end of the century, 60 million people who reside in the coastal areas will be forced to move as a result of rising sea levels in the country.<sup><a href="https://philippines.un.org/en/156235-climate-crisis-game-changer-when-it-comes-migration" target="_blank" rel="noreferrer">[12]</a></sup>`,
    image: "/images/phillipines/story-2.webp",
  },
  {
    heading:
      "Labour Rights Index score higher than the regional average in Philippines",
    text: `According to the Labour Rights Index (2022), Philippines has ‘reasonable access to work’, its score being higher than the overall average in the Southeast Asian region.<sup><a href="https://labourrightsindex.org/heatmap-2022" target="_blank" rel="noreferrer">[13]</a></sup> However, compliance related challenges exist in the country. For example, in the garment sector, the non-compliance rate with minimum wage is 53.3% with a significant gender compliance gap i.e., 14.3%.<sup><a href="https://www.ilo.org/wcmsp5/groups/public/---ed_protect/---protrav/---travail/documents/publication/wcms_509532.pdf" target="_blank" rel="noreferrer">[14]</a></sup>`,
    image: "/images/phillipines/story-3.webp",
  },
  {
    heading:
      "The Philippines is moving towards a uniform digital national ID to overcome documentation challenges",
    text: `Social safety nets in the Philippines have focused on three major themes which include food subsidies, public employment programs and credit-based livelihood programs.<sup><a href="https://www.adb.org/sites/default/files/publication/162012/social-protection-project-phi.pdf" target="_blank" rel="noreferrer">[15]</a></sup> In 2019, it was observed 36.7% of the population had coverage of social protection schemes in the country while 90.4% of the population was covered by the health insurance scheme.<sup><a href="https://www.social-protection.org/gimi/ShowCountryProfile.action?iso=PH#:~:text=The%20Government%20of%20the%20Philippines,interventions%2C%20and%20social%20safety%20nets." target="_blank" rel="noreferrer">[16]</a></sup> As a response to major documentation and identity proof related challenges to access schemes the government recently launched the Philippine Identification System (PhilSys), creating a uniform digital ID for its nationals.<sup><a href="https://www.worldbank.org/en/news/opinion/2021/10/14/transforming-social-protection-delivery-in-the-philippines-through-philsys" target="_blank" rel="noreferrer">[17]</a></sup> However, since its launch the ID registrations and roll out has faced numerous administrative challenges with physical IDs having only reached 37 million approximately out of the 80 million target.<sup><a href=https://dig.watch/updates/slow-distribution-of-digital-ids-in-the-philippines-due-to-low-quality-webcams-and-the-digital-divide" target="_blank" rel="noreferrer">[18]</a></sup> With most government and private benefits requiring this ID, if not rolled out to the entire population significant access related challenges could be faced in the future.`,
    image: "/images/phillipines/story-4.webp",
  },
];

export const learnMore = [
  {
    link: "#",
    text: "Overview of internal migration in Philippines",
  },
  {
    link: "https://www.uppi.upd.edu.ph/sites/default/files/pdf/2018 NMS Final Report.pdf",
    text: "National Migration Survey 2018",
  },
];
